const imgpath = 'files/public/bera/images/GROSS_bera_fin_ES_OP';


const images = [
    { id: 1, src: imgpath+'titel.jpg', category: 1 },
    { id: 2, src: imgpath+'2.jpg', category: 1 },
    { id: 3, src: imgpath+'3.jpg', category: 1 },
    { id: 4, src: imgpath+'4.jpg', category: 2 },
    { id: 5, src: imgpath+'5.jpg', category: 2 },
    { id: 6, src: imgpath+'6.jpg', category: 3 },
    { id: 7, src: imgpath+'7.jpg', category: 3 },
    { id: 8, src: imgpath+'9.jpg', category: 4 },
    { id: 9, src: imgpath+'10.jpg', category: 4 },
    { id: 10, src: imgpath+'11.jpg', category: 4 },
    { id: 11, src: imgpath+'12.jpg', category: 4 },
    { id: 12, src: imgpath+'13.jpg', category: 4 },
    { id: 13, src: imgpath+'14.jpg', category: 4 },
    { id: 14, src: imgpath+'15.jpg', category: 4 },
    { id: 15, src: imgpath+'16.jpg', category: 4 },
    { id: 16 , src: imgpath+'17.jpg', category: 4 },
    { id: 17, src: imgpath+'18.jpg', category: 4 },
    { id: 18 , src: imgpath+'19.jpg', category: 4 },
    { id: 19, src: imgpath+'20.jpg', category: 4 },
    { id:20, src: imgpath+'21.jpg', category: 4 },
    { id:21 , src: imgpath+'22.jpg', category: 4 },
    { id:22 , src: imgpath+'23.jpg', category: 4 },
    { id:23 , src: imgpath+'24.jpg', category: 4 },
    { id:24 , src: imgpath+'25.jpg', category: 4 },
    { id:25 , src: imgpath+'26.jpg', category: 4 },
    { id:26 , src: imgpath+'27.jpg', category: 4 },
    { id:27 , src: imgpath+'28.jpg', category: 4 },
    { id: 28, src: imgpath+'29.jpg', category: 4 },
    { id: 29, src: imgpath+'31.jpg', category: 5 },
    { id: 30, src: imgpath+'32.jpg', category: 5 },
    { id: 31, src: imgpath+'33.jpg', category: 5 },
    { id: 32, src: imgpath+'34.jpg', category: 5 },
    { id: 33, src: imgpath+'35.jpg', category: 5 },
    { id: 34, src: imgpath+'36.jpg', category: 5 },
    { id: 35, src: imgpath+'37.jpg', category: 5 },
    { id:36 , src: imgpath+'39.jpg', category: 6 },
    { id: 37, src: imgpath+'40.jpg', category: 6 },
    { id: 38, src: imgpath+'41.jpg', category: 6 },
    { id: 39, src: imgpath+'42.jpg', category: 6 },
    { id: 40, src: imgpath+'43.jpg', category: 6 },
    { id:41 , src: imgpath+'44.jpg', category: 6 },
    { id: 42, src: imgpath+'45.jpg', category: 6 },
    { id:43 , src: imgpath+'46.jpg', category: 6 },
    { id: 44, src: imgpath+'47.jpg', category: 6 },
    { id: 45, src: imgpath+'48.jpg', category: 6 },
    { id: 46, src: imgpath+'49.jpg', category: 6 },
    { id:47 , src: imgpath+'50.jpg', category: 6 },
    { id:48 , src: imgpath+'51.jpg', category: 6 },
    { id:49 , src: imgpath+'52.jpg', category: 6 },
    { id: 50, src: imgpath+'53.jpg', category: 6 },
    { id: 51, src: imgpath+'54.jpg', category: 6 },
    { id: 52, src: imgpath+'55.jpg', category: 6 },
    { id: 53, src: imgpath+'56.jpg', category: 6 },
    { id: 54, src: imgpath+'57.jpg', category: 6 },
    { id: 55, src: imgpath+'59.jpg', category: 7 },
    { id:56 , src: imgpath+'60.jpg', category: 7 },
    { id:57 , src: imgpath+'61.jpg', category: 7 },
    { id:58 , src: imgpath+'62.jpg', category: 7 },
    { id: 59 , src: imgpath+'63.jpg', category: 7 },
    { id: 60, src: imgpath+'64.jpg', category: 7 },
    { id: 61 , src: imgpath+'65.jpg', category: 7 },
    { id: 62, src: imgpath+'66.jpg', category: 7 },
    { id: 63, src: imgpath+'67.jpg', category: 7 },
    { id: 64, src: imgpath+'69.jpg', category: 8 },
    { id: 65, src: imgpath+'70.jpg', category: 8 },
    { id: 66 , src: imgpath+'71.jpg', category: 8 },
    { id: 67, src: imgpath+'72.jpg', category: 8 },
    { id: 68, src: imgpath+'73.jpg', category: 8 },
    { id: 69, src: imgpath+'74.jpg', category: 8 },
    { id: 70, src: imgpath+'75.jpg', category: 8 },
    { id: 71, src: imgpath+'76.jpg', category: 8 },
    { id: 72, src: imgpath+'77.jpg', category: 8 },
    { id: 73, src: imgpath+'79.jpg', category: 9 },
    { id: 74, src: imgpath+'80.jpg', category: 9 },
    { id: 75, src: imgpath+'81.jpg', category: 9 },
    { id: 76, src: imgpath+'82.jpg', category: 9 },
    { id: 77, src: imgpath+'83.jpg', category: 9 },
    { id: 78, src: imgpath+'84.jpg', category: 9 },
    { id: 79, src: imgpath+'85.jpg', category: 9 },
    { id: 80, src: imgpath+'86.jpg', category: 9 },
    { id: 81, src: imgpath+'87.jpg', category: 9 },
    { id: 82, src: imgpath+'88.jpg', category: 9 },
    { id: 83, src: imgpath+'89.jpg', category: 9 },
    { id: 84, src: imgpath+'90.jpg', category: 9 },
    { id: 85, src: imgpath+'91.jpg', category: 9 },
    { id: 86, src: imgpath+'92.jpg', category: 9 },
    { id: 87, src: imgpath+'93.jpg', category: 9 },
    { id: 88, src: imgpath+'94.jpg', category: 10 },


];
export default images;